// Web stub for react-native-safe-area-context.
// On web, safe-area insets are handled by CSS env(safe-area-inset-*).
// These components pass children through with optional padding.

import type { ReactNode } from 'react';
import { View } from 'react-native';

export function SafeAreaProvider({ children }: { children: ReactNode }) {
  return <>{children}</>;
}

export function SafeAreaView({
  children,
  className,
  style,
  edges,
}: {
  children?: ReactNode;
  edges?: Array<'top' | 'right' | 'bottom' | 'left'>;
  className?: string;
  style?: any;
}) {
  const resolvedEdges = edges ?? ['top', 'right', 'bottom', 'left'];
  return (
    <View
      className={className}
      style={[
        {
          paddingTop: resolvedEdges.includes('top')
            ? 'env(safe-area-inset-top, 0px)'
            : undefined,
          paddingBottom: resolvedEdges.includes('bottom')
            ? 'env(safe-area-inset-bottom, 0px)'
            : undefined,
          paddingLeft: resolvedEdges.includes('left')
            ? 'env(safe-area-inset-left, 0px)'
            : undefined,
          paddingRight: resolvedEdges.includes('right')
            ? 'env(safe-area-inset-right, 0px)'
            : undefined,
        } as any,
        style,
      ]}
    >
      {children}
    </View>
  );
}

export function useSafeAreaInsets() {
  return { top: 0, right: 0, bottom: 0, left: 0 };
}
